var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHirePep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9 3.5606C26.82 4.0606 26.78 4.5606 26.78 5.0606C26.78 9.5606 30.42 13.1986 34.9 13.1986C35.4 13.1986 35.88 13.1406 36.38 13.0606V29.1986C36.38 35.9806 32.38 40.0006 25.58 40.0006H10.802C4 40.0006 0 35.9806 0 29.1986V14.4006C0 7.6006 4 3.5606 10.802 3.5606H26.9ZM27.302 15.7206C26.76 15.6606 26.222 15.9006 25.9 16.3406L21.062 22.6006L15.52 18.2406C15.18 17.9806 14.78 17.8786 14.38 17.9206C13.982 17.9806 13.622 18.1986 13.38 18.5186L7.462 26.2206L7.34 26.4006C7 27.0386 7.16 27.8586 7.76 28.3006C8.04 28.4806 8.34 28.6006 8.68 28.6006C9.142 28.6206 9.58 28.3786 9.86 28.0006L14.88 21.5386L20.58 25.8206L20.76 25.9386C21.4 26.2786 22.2 26.1206 22.66 25.5186L28.44 18.0606L28.36 18.1006C28.68 17.6606 28.74 17.1006 28.52 16.6006C28.302 16.1006 27.82 15.7606 27.302 15.7206ZM35.1802 0C37.8402 0 40.0002 2.16 40.0002 4.82C40.0002 7.48 37.8402 9.64 35.1802 9.64C32.5202 9.64 30.3602 7.48 30.3602 4.82C30.3602 2.16 32.5202 0 35.1802 0Z",
    fill: "#2C8FCA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHirePep);
export default __webpack_public_path__ + "static/media/hire-pep.355e48923ea931951e0d69299ecc04e6.svg";
export { ForwardRef as ReactComponent };